'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import axios from 'axios';

export default function ShortenPage() {

    const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
    const shortURL = process.env.NEXT_PUBLIC_SHORT_URL;
    const [userNiceName, setUserNicename] = useState('');
    const [token, setToken] = useState('');

    const router = useRouter();

    useEffect(() => {
        const localToken = sessionStorage.getItem('token');
        setToken(localToken);
        if (!localToken) {
            router.push('/login');
        } else {

            const user = JSON.parse(localStorage.getItem('user'));
            setUserNicename(user.user_display_name);
        }

    }, []);

    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [shortUrl, setShortUrl] = useState('');
    const [shortCode, setShortCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [copied, setCopied] = useState({ url: false, code: false });

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setShortUrl('');
        setShortCode('');
        setError(null);
        setCopied({ url: false, code: false });

        try {
            console.log(`${baseURL}/api/shorturl/v1/create`)
            console.log(token)
            const response = await axios.post(
                `${baseURL}/api/shorturl/v1/create`,
                {
                    url: url,
                    title: title // Custom post title
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            // setShortUrl(response.data.short_url);
            setShortUrl(`${shortURL}${response.data.short_code}`);
            setShortCode(response.data.short_code);
        } catch (err) {
            setError('خطأ أثناء محاولة اختصار الرابط ، فضلاً حاول مرة أخرى<');
        } finally {
            setLoading(false);
        }
    }

    const copyToClipboard = (text, type) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied((prev) => ({ ...prev, [type]: true }));
            setTimeout(() => setCopied((prev) => ({ ...prev, [type]: false })), 2000);
        });
    };

    return (
        <div className="max-w-xl mx-auto p-6">
            {/* {baseURL} */}
            {/* <h1 className="text-2xl font-semibold mb-4">🔗 Shorten a URL</h1> */}
            <h1 className="text-2xl font-semibold mb-1">🔗 اختصار الروابط , مُختصر الروابط </h1>
            <p className='mb-1'>{userNiceName && <p className="lead">أهلاً بعودتك , <b>{userNiceName}</b> 👋 </p>}</p>

            <p>لاحظنا معاناة الفيجماوية .. وقررنا نشوف لها حل </p>

            <form onSubmit={handleSubmit} className="space-y-4 mb-3">
                <input
                    type="url"
                    required
                    placeholder=" الصق الرابط المُراد اختصاره هنا ..."
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded  form-control"
                />
                <input
                    type="text"
                    placeholder="اختياري : كتابة وصف بسيط للرابط"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded form-control"
                />
                <button
                    type="submit"
                    disabled={loading}
                    className="btn btn-dark hover:bg-blue-700 text-white px-6 py-2 rounded"
                >
                    {/* {loading ? 'Shortening...' : 'Shorten URL'} */}
                    {loading ? 'جار اختصار الرابط ...' : 'اختصر الرابط'}
                </button>
            </form>

            {shortUrl && (
                <div className="mt-6 p-4 bg-green-50 border border-green-300 rounded space-y-2">
                    <div>
                        <p className="text-green-800">✅ الرابط المختصر :</p>
                        <div className="flex items-center gap-2">
                            <a
                                href={shortUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                {shortUrl}
                            </a>
                            <button
                                onClick={() => copyToClipboard(shortUrl, 'url')}
                                className="text-xs bg-blue-100 px-2 py-1 rounded"
                            >
                                {/* {copied.url ? 'Copied!' : 'Copy URL'} */}
                                {copied.url ? 'تم النسخ' : 'نسخ الرابط'}
                            </button>
                        </div>
                    </div>

                    <div>
                        <p className="text-green-800">🔑 Short code:</p>
                        <div className="flex items-center gap-2">
                            <code className="bg-gray-100 px-2 py-1 rounded">{shortCode}</code>
                            <button
                                onClick={() => copyToClipboard(shortCode, 'code')}
                                className="text-xs bg-blue-100 px-2 py-1 rounded"
                            >
                                {copied.code ? 'تم النسخ' : 'نسخ الكود'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <p className='alert alert-warning mt-4'> قريباً ، إمكانية استخدامها من داخل فيجما Plugins 😊😃</p>

            {error && <div className="mt-4 text-red-600">{error}</div>}


            <div className="container mt-5">
                {/* <h1 className="mb-4">Welcome to the Dashboard</h1> */}
                {/* {userNiceName && <p className="lead">أهلاً بعودتك , {userNiceName} 👋 </p>} */}
                <button className="btn btn-danger" onClick={() => {
                    sessionStorage.removeItem('token');
                    localStorage.removeItem('user');
                    router.push('/login');
                }}>
                    تسجيل خروج
                </button>
            </div>
        </div>
    );
} 
